<template>
  <v-row>
    <v-col v-if="isloading" cols="12" class="justify-center d-flex">
      <v-progress-circular
        :size="50"
        color="primary"
        indeterminate
      ></v-progress-circular>
    </v-col>
    <v-col cols="12" class="justify-center d-flex">
      <v-chip-group column text-color="white" dark>
        <template v-for="(item, index) in Balance">
          <v-chip
            pill
            :color="colorName"
            text-color="white"
            active-class="green"
            light
            :key="index"
            >{{ item.Amount.toLocaleString() }}
            <v-avatar
              size="avatarSize"
              :color="item.loan === 'yess' ? '#D50000' : '#FFECB3'"
              class="black--text pa-4 my-4"
              right
            >
              {{ item.AmountType | MoneySigns }}
            </v-avatar>
          </v-chip>
        </template>
      </v-chip-group>
    </v-col>
  </v-row>
</template>
<script>
export default {
  props: {
    Balance: { type: Array },
    isloading: { type: Boolean },
    colorName: { type: String, default: "indigo" },
  },
};
</script>
